export const GET_LONG_LIVED_FB_USER_ACCESS_TOKEN =
  "GET_LONG_LIVED_FB_USER_ACCESS_TOKEN";
